import { FormInstance } from 'antd/lib'
import {
  TickerManagementForm,
  TickerManagementFormFieldTypes,
} from './ticker-management-form.tsx'
import { ManagedTickerData } from '../../../../../apis/ticker-management/ticker-management-api.def.ts'
import React, { useEffect } from 'react'
import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import { useTranslation } from 'react-i18next'

interface ActionTickerModalProps {
  showActionModal: boolean
  form: FormInstance<TickerManagementFormFieldTypes>
  handleCloseModal: () => void
  tickerData: ManagedTickerData
}

export const ActionTickerModal: React.FC<ActionTickerModalProps> = ({
  showActionModal,
  form,
  handleCloseModal,
  tickerData,
}) => {
  const { t } = useTranslation()
  useEffect(() => {
    if (tickerData) {
      form.setFieldsValue({
        bbgCompositeKey: tickerData.bbgCompositeKey,
        region: tickerData.region,
        canLong: tickerData.canLong,
        canShort: tickerData.canShort,
        startDate: tickerData.startDate,
        endDate: tickerData.endDate,
        isAdr: tickerData.isAdr,
      })
    }
  }, [tickerData, form])

  const handleCloseAndClear = () => {
    handleCloseModal()
    form.resetFields()
  }

  return (
    <IdeyaModal
      open={showActionModal}
      title={
        tickerData
          ? t('ticker_management.ticker_modal.edit_ticker')
          : t('ticker_management.ticker_modal.add_ticker')
      }
      destroyOnClose
      isForm={true}
      onCancel={handleCloseAndClear}
    >
      <TickerManagementForm
        mode={tickerData ? 'edit' : 'create'}
        editTickerId={tickerData?.id}
        onCancel={handleCloseAndClear}
        form={form}
      />
    </IdeyaModal>
  )
}
